// this gets instantiated by NotificationService.vue for global use

export const notification = {
  toast: null,
  confirm: null,
}
